module.exports = __webpack_public_path__ + "static/media/ic-edit-pencil.6bae3715.svg";